import { render, staticRenderFns } from "./SubmitForm13.vue?vue&type=template&id=7047a06a&scoped=true"
import script from "./SubmitForm13.vue?vue&type=script&lang=ts"
export * from "./SubmitForm13.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7047a06a",
  null
  
)

export default component.exports